module.exports = __webpack_public_path__ + "img/3.4b40af12.png";